<!--
 * @Author: your name
 * @Date: 2021-04-12 16:12:42
 * @LastEditTime: 2021-08-30 15:12:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\views\home\layout\EcHeader.vue
-->
<template>
  <div class="ec-header flex-space-between">
      <div class="ec-left title">
        <!-- <ec-breadcrumb/> -->
        <!-- <logo v-if="showLogo" :collapse="isCollapse"/> -->
        <!-- <div class="logo-title">智能锁管理平台<span class="version">v1.1.0</span></div> -->
        <!-- <ec-breadcrumb/> -->
      </div>
      <div class="ec-right">
        <!-- <ec-header-about></ec-header-about>
        <ec-header-help></ec-header-help> -->
        <ec-header-screen></ec-header-screen>
        <ec-header-download></ec-header-download>
        <ec-header-pw></ec-header-pw>
        <ec-header-logout></ec-header-logout>
    </div>
  </div>
</template>
<script>
import EcHeaderHelp from '../components/EcHeaderHelp'
import EcHeaderLogout from '../components/EcHeaderLogout'
import EcHeaderScreen from '../components/EcHeaderScreen'
import EcHeaderPw from '../components/EcHeaderPw'
import EcHeaderDownload from '../components/EcHeaderDownload'

import { mapState } from "vuex";
import EcHeaderAbout from '../components/EcHeaderAbout'
import Logo from './Logo'
export default {
  name: 'EcHeader',
  components: {
    EcHeaderHelp,
    EcHeaderLogout,
    EcHeaderPw,
    EcHeaderAbout,
    Logo,
    EcHeaderScreen,
    EcHeaderDownload
  },
    computed: {
    ...mapState(["isCollapse"]),
    showLogo() {return true;},
    isCollapse() {
      return this.$store.state.isCollapse
    }
  },
}
</script>
<style scoped lang="scss">
@import "~@/styles/theme/variables.scss";
.ec {
  &-header {
    height: 50px;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(2, 30, 29, 0.15);
    padding-right: 16px;
    padding-left: 16px;
    background: rgb(36, 44, 51);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 10;
  }
}
.title {
  padding-left: 200px;
  font-size: 14px;
color: #ffff;
letter-spacing: 0;
font-weight: 400;
// margin-left: 9px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/layout/EcHeader.vue